import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { KsefApiService } from '../../services/ksef-api.service';
import { KsefInvoice } from '../../models/ksef-invoice.model';
import { Roles } from 'src/app/shared/models/auth/role.model';

@Component({
  selector: 'app-ksef-in-circulation-list',
  templateUrl: './ksef-in-circulation-list.component.html',
})
export class KsefInCirculationListComponent implements OnInit {
  invoices$!: Observable<KsefInvoice[]>;
  Roles = Roles;

  constructor(private ksefApi: KsefApiService) {}

  ngOnInit(): void {
    this.invoices$ = this.ksefApi.getInCirculationInvoices().pipe(shareReplay(1));
  }
}
